import { ElectricLoad } from '../../../../../../domain/ElectricLoad';
import { Percent } from '../../../../../../domain/Percent';
import { AttentionStatus } from '../../../../../AttentionStatus';
import {
  EvaluationResult,
  type EvaluationResultType
} from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class LoadingPercentEvaluation {
  private readonly ruleName = 'Lv_AcLineSegment_LoadingPercent';

  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluate(loading: number): EvaluationResultType<ElectricLoad> {
    const rule = this.rulesProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(rule?.value, loading);
    const value = ElectricLoad.fromPercent(Percent.fromFloat(loading));
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
